<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Number, Boolean],
        default: ''
    },
    label: {
        type: String,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const group = inject('radioGroup');

const checked = computed(() => props.modelValue === group.modelValue.value);

function update(event) {
    if (event.target.checked) {
        group.update(event.target.value);
    }
}
</script>

<template>
    <label :disabled="disabled" class="custom-radio">
        <input
            type="radio"
            :value="modelValue"
            :name="group.name.value"
            :checked="checked"
            :disabled="group.busy || disabled"
            :class="{ 'bg-dust-100': disabled }"
            @change="update"
        >
        <span class="custom-radio__label">{{ label }}</span>
    </label>
</template>
